var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUnion = function SvgIconUnion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.944 9.965V6.661c-3.527 0-5.937.319-7.777 3.648 0 0 1.277-7.445 7.777-7.445V0L14.5 5.154 8.944 9.965Zm-2.888.07v3.304c3.527 0 5.937-.319 7.777-3.648 0 0-1.277 7.446-7.777 7.446V20L.5 14.846l5.556-4.811Z",
    fill: "#767978"
  })));
};
export default SvgIconUnion;